import React from 'react'
import PropTypes from 'prop-types'

import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'
import { withStyles } from '@material-ui/core/styles'

import AccessListEmptyState from './AccessListEmptyState'
import AccessUserEditLink from './AccessUserEditLink'
import AddAccessToUnitButton from './AddAccessToUnitButton'
import DeleteUsersButton from './DeleteUsersButton'
import DisableUsersButton from './DisableUsersButtonContainer'
import EnableUsersButton from './EnableUsersButtonContainer'
import CommunityAccessChip from './CommunityAccessChipContainer'
import UnitAccessChip from './UnitAccessChipContainer'

class UnitDoorAccessList extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    accessIds: PropTypes.array.isRequired,
    checkedIds: PropTypes.array.isRequired,
    onToggleCheckAll: PropTypes.func.isRequired,
    onToggleCheckbox: PropTypes.func.isRequired,
    unit: PropTypes.object.isRequired,
    rows: PropTypes.array.isRequired,
  }

  static styles = (theme) => ({
    paper: {
      padding: '0 0 20px 0',
      marginTop: theme.spacing(3),
    },
    highlighted: {
      backgroundColor: fade('#000', 0.04),
    },
    toolbarHighlighted: {
      backgroundColor: fade(theme.palette.primary.main, 0.12),
    },
    toolbarControls: {
      flex: '1',
      textAlign: 'right',
    },
    table: {
      width: 'auto',
      margin: '0 24px',
      '& td': {
        padding: 0,
        '&:last-child': {
          paddingRight: 0,
        },
      },
      '& th': {
        padding: 0,
        '&.headerText': {
          padding: '0 10px',
        },
      },
    },
  })

  renderRow = (row) => {
    const { checkedIds, classes, unit } = this.props
    const { accessId } = row
    const communityId = unit.community_id
    const unitId = unit.id
    const isChecked = checkedIds.includes(accessId)

    return (
      <TableRow key={accessId} className={isChecked ? classes.highlighted : ''}>
        <TableCell>
          <Checkbox
            color="primary"
            checked={isChecked}
            onChange={(_, checked) => this.props.onToggleCheckbox(checked, accessId)}
          />
        </TableCell>
        <TableCell>
          <AccessUserEditLink accessId={accessId} />
        </TableCell>
        <TableCell align="right">
          { row.hasCommunityAccess
            && (
              <CommunityAccessChip
                key={`${accessId}-${communityId}`}
                accessId={accessId}
                communityId={communityId}
              />
            )}
          { row.hasUnitAccess
            && (
              <UnitAccessChip
                key={`${accessId}-${unitId}`}
                accessId={accessId}
                unitId={unitId}
              />
            )}
        </TableCell>
      </TableRow>
    )
  }

  renderList = () => {
    const {
      accessIds,
      checkedIds,
      classes,
      rows,
    } = this.props
    const isAllChecked = (checkedIds.length === accessIds.length)
    const isAllCheckedIndeterminate = (checkedIds.length > 0 && !isAllChecked)

    if (rows.length) {
      return (
        <Table classes={{ root: classes.table }}>
          <colgroup>
            <col width="1%" />
            <col />
            <col width="50%" />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell>
                <Checkbox
                  checked={isAllChecked}
                  onChange={this.props.onToggleCheckAll}
                  indeterminate={isAllCheckedIndeterminate}
                />
              </TableCell>
              <TableCell className="headerText">
                User
              </TableCell>
              <TableCell align="right" className="headerText">
                Door Access
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => this.renderRow(row))}
          </TableBody>
        </Table>
      )
    }

    return (
      <AccessListEmptyState>
        <div>Looks like nobody has access to this unit.</div>
        <div>Add a person to this unit here.</div>
      </AccessListEmptyState>
    )
  }

  renderTitleToolbar = () => {
    const { classes, checkedIds, unit } = this.props
    const communityId = unit.community_id
    const checkedCount = checkedIds.length

    if (checkedCount > 0) {
      return (
        <Toolbar className={classes.toolbarHighlighted}>
          <Typography variant="subtitle1">
            {checkedCount} selected
          </Typography>
          <div className={classes.toolbarControls}>
            <DisableUsersButton accessIds={checkedIds} communityId={communityId} />
            <EnableUsersButton accessIds={checkedIds} communityId={communityId} />
            <DeleteUsersButton accessIds={checkedIds} communityId={communityId} />
          </div>
        </Toolbar>
      )
    }

    return (
      <Toolbar>
        <Typography variant="h6">
          {unit.name} Door Access
        </Typography>
        <div className={classes.toolbarControls}>
          <AddAccessToUnitButton unit={unit} />
        </div>
      </Toolbar>
    )
  }

  render() {
    return (
      <Paper className={this.props.classes.paper} elevation={0}>
        { this.renderTitleToolbar() }
        { this.renderList() }
      </Paper>
    )
  }
}

export default withStyles(UnitDoorAccessList.styles)(UnitDoorAccessList)
